export const BUNDLE_LIST = [
  {
    key: "TYPE",
    value: "type",
    width: 0.27,
  },
  {
    key: "SUBSCRIPTION",
    value: "subscription",
    width: 0.7,
  },
  {
    key: "ASSIGNED HARDWARE",
    value: "assignedhardware",
    width: 0.7,
  },
  {
    key: "HARDWARE SPECIFIER",
    value: "hardwarespecifier",
    width: 0.7,
  },
  {
    key: "LINE TYPE",
    value: "linetype",
    width: 0.2,
  },
  {
    key: "HARDWARE CHANGES",
    value: "hardwarechanges",
    width: 0.8,
  },
  {
    key: "APPROVED CHANGES",
    value: "approvedchanges",
    width: 0.8,
  },
];

export const BADGE_STYLE = {
  core: {
    backgroundColor: "#0077B4",
    color: "white",
  },
  feature: {
    backgroundColor: "white",
    color: "black",
  },
  companion: {
    backgroundColor: "black",
    color: "white",
  },
};

export const HARDWARE_REQUEST_STATUS = {
  CREATED: "Created",
  MODIFIED_PENDING_AGENT: "Pending Agent",
  MODIFIED: "Modified",
  REVERTED_PENDING_AGENT: "Pending Agent",
  CANCELLED: "Cancelled",
  APPROVED: "Approved",
  REVERTED: "Reverted",
  PENDING_AGENT: "Pending Agent",
};
